import { Box, Text } from 'grommet';
import { PrimaryButton, FrostedGlassBox } from "../components";

const LinksSection = ({ reportData, isMobile }) => {
    const links = reportData?.links;
    return (
        <FrostedGlassBox>
            <div class="container">
                <Box margin={'1rem'} style={{ display: "block" }} flex="shrink">
                    <Text size="large">{`Links`}</Text>
                    <Box margin={{ top: '0.49rem' }}></Box>
                    {
                        links?.corelogic && (
                            <PrimaryButton
                                isMobile={isMobile}
                                label="CoreLogic"
                                url={links?.corelogic}
                                icon="https://auth.corelogic.asia/assets/favicon.png" />
                        )
                    }
                    {
                        links?.property && (
                            <PrimaryButton
                                isMobile={isMobile}
                                label="Property&nbsp;&nbsp;&nbsp;&nbsp;"
                                url={links?.property}
                                icon="https://pca-core-web-assets.property-research-prod.property.com.au/favicon.ico" />
                        )
                    }
                    {
                        links?.realestate && (
                            <PrimaryButton
                                isMobile={isMobile}
                                label="Realestate"
                                url={links?.realestate}
                                icon="https://assets.reastatic.net/realestate.com.au/favicon.ico" />
                        )
                    }
                    {
                        links?.domain && (
                            <PrimaryButton
                                isMobile={isMobile}
                                label="Domain&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                                url={links?.domain}
                                icon="https://static.domain.com.au/domain/favicon.ico" />
                        )
                    }
                    {
                        links?.landchecker && (
                            <PrimaryButton
                                isMobile={isMobile}
                                label="Landchecker"
                                url={links?.landchecker}
                                icon="https://app.landchecker.com.au/favicon.ico" />
                        )
                    }
                </Box>
            </div>
        </FrostedGlassBox>
    )
};

export { LinksSection };